<template>
  <div :class="!isMobile ? 'categories' : 'menu'">
      <ul>
        <li ><a :class="{ active: currentCategory == 'all'}" @click="change('all')" href="javascript:;">Tümü</a></li>

        <li>
          <a :class="{ active: currentCategory == 'fav'}" @click="change('fav')" href="javascript:;">
            Favori <slot v-if="!isMobile">Oyunlar</slot>
          </a>
        </li>
        <li>
          <a :class="{ active: currentCategory == 'jackpot'}" @click="change('jackpot')" href="javascript:;">
            Jackpot <slot v-if="!isMobile">Oyunları</slot>
          </a>
        </li>
        <li v-if="currentProvider == 'pragmaticplay'">
          <a :class="{ active: currentCategory == 'dropwins'}" @click="change('dropwins')" href="javascript:;">
            Drop&Wins <slot v-if="!isMobile">Oyunları</slot>
          </a>
        </li>
        <li v-if="currentProvider == 'egtd'">
          <a :class="{ active: currentCategory == 'dropwins'}" @click="change('dropwins')" href="javascript:;">
            Clover Chance
          </a>
        </li>
        <li v-if="currentProvider == 'egtd'">
          <a :class="{ active: currentCategory == 'high'}" @click="change('high')" href="javascript:;">
            High Cash
          </a>
        </li>
        <li v-if="currentProvider == 'egtd'">
          <a :class="{ active: currentCategory == 'bell'}" @click="change('bell')" href="javascript:;">
            Bell Link
          </a>
        </li>
        <li v-if="currentProvider == 'egtd'">
          <a :class="{ active: currentCategory == 'vip_bell'}" @click="change('vip_bell')" href="javascript:;">
           Vip Bell Link
          </a>
        </li>
      </ul>
    <Search v-if="!isMobile"/>
  </div>
</template>
<script>
  import Search from './Search'
  export default{
    methods:{
      changeCategory(){
      }
    },
    computed:{
      categories(){
        return this.$store.getters['slot/getCurrentCategories'];
      },
      currentProvider(){
        return this.$store.getters['slot/getCurrentProvider'];
      },
      currentCategory(){
        return this.$store.getters['slot/getCurrentCategory'];
      },
    },
    components:{
      Search
    },  
    methods:{
      change(provider){
        this.$emit('menuChange', 'games');
        this.$store.dispatch('slot/changeCategory', [provider])
      }
    }
  }
</script>